module.exports = "/*@import './cot-form-control/cot-form-control.component.scss';*/\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widgets-custom-theme.scss
// module id = ./src/app/widgets/widgets-custom-theme.scss
// module chunks = main